import { render, staticRenderFns } from "./PdfHome.vue?vue&type=template&id=2b7a6a1a&scoped=true&"
import script from "./PdfHome.vue?vue&type=script&lang=js&"
export * from "./PdfHome.vue?vue&type=script&lang=js&"
import style0 from "./PdfHome.vue?vue&type=style&index=0&id=2b7a6a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a6a1a",
  null
  
)

export default component.exports